import { yupResolver } from "@hookform/resolvers/yup";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { importCsvFormSchema } from "../../validations";
import Button from "../controls/Button";

interface Props {
  title?: string;
  description?: any;
  label?: string;
  className?: string;
  value?: string;
  isBusy?: boolean;
  info?: React.ReactNode;
  onSubmit: (val: object) => void | undefined;
  closeModal: () => void | undefined;
}

const ImportCsv = (props: Props) => {
  const [csvfile, setCsvfile] = useState();

  const {
    title = "",
    description = "",
    className,
    onSubmit,
    closeModal,
  } = props;

  const { handleSubmit } = useForm({
    defaultValues: {
      file: "",
    },
    mode: "all",
    reValidateMode: "onChange",
    resolver: yupResolver(importCsvFormSchema),
  });

  const onSubmitHandler = () => {
    //console.log("isBusy : ", isBusy, setError, getValues);
    onSubmit({ file: csvfile });
  };

  const onCloseModal = () => {
    closeModal();
  };

  const handleOnChange = (e: any) => {
    setCsvfile(e.target.files[0]);
  };

  return (
    <div className={className}>
      <div>
        <form
          className="w-full bg-white border rounded-lg border-[#8138df] border-opacity-0 px-3 pt-1 pb-4 mb-4"
          onSubmit={handleSubmit(onSubmitHandler)}
        >
          <div>
            <div>
              <input
                accept={".csv"}
                className="bg-[#8138df0d] relative m-0 block w-full min-w-0 flex-auto rounded border border-solid border-neutral-300 bg-clip-padding px-3 py-[0.32rem] text-base font-normal text-neutral-700 transition duration-300 ease-in-out file:-mx-3 file:-my-[0.32rem] file:overflow-hidden file:rounded-none file:border-0 file:border-solid file:border-inherit file:bg-neutral-100 file:px-3 file:py-[0.32rem] file:text-neutral-700 file:transition file:duration-150 file:ease-in-out file:[border-inline-end-width:1px] file:[margin-inline-end:0.75rem] hover:file:bg-neutral-200 focus:border-primary focus:text-neutral-700 focus:shadow-te-primary focus:outline-none dark:border-neutral-600 dark:text-neutral-200 dark:file:bg-neutral-700 dark:file:text-neutral-100 dark:focus:border-primary"
                type={"file"}
                id="formFileMultiple"
                name="file"
                onChange={handleOnChange}
              />
            </div>
            <div>
              <p className="text-base mt-2">{title}</p>
              <div className="text-base mt-2">{description}</div>
            </div>
          </div>
          <div className="flex items-center justify-center mt-5 gap-7 border-t-2">
            <div className="flex flex-row-reverse justify-end gap-4 mt-6">
              <Button variant="contained" type="submit" className="!w-full">
                Submit
              </Button>
              <Button
                variant="outlined"
                className="!w-full"
                type="button"
                onClick={onCloseModal}
              >
                Cancel
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ImportCsv;
